import React, { useState } from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import Seo from "@/components/Seo";
import PageHero from "@/components/PageHero";
import { Reveal } from "@/components/Reveal";
import CTASection from "@/components/CTASection";
import { ARTICLES } from "@/data/site";

const CATEGORIES = ["Tous", ...Array.from(new Set(ARTICLES.map((a) => a.category)))];

export default function Blog() {
  const [cat, setCat] = useState("Tous");
  const list = cat === "Tous" ? ARTICLES : ARTICLES.filter((a) => a.category === cat);

  return (
    <>
      <Seo
        title="Blog & Conseils Recherche de Fuite d'Eau | FuiteX"
        description="Conseils d'experts sur la recherche de fuite d'eau : signes d'une fuite invisible, prix, assurance, humidité. Le blog FuiteX."
        canonical="/blog"
      />
      <PageHero
        overline="Blog & conseils"
        titleLines={["Nos conseils sur", "la fuite d'eau"]}
        subtitle="Comprendre, prévenir et réagir face à une fuite d'eau : nos guides pratiques pour y voir plus clair."
        breadcrumb={[{ label: "Blog" }]}
      />

      <section className="bg-white py-24">
        <div className="container-x">
          <div className="flex flex-wrap gap-2.5 mb-12">
            {CATEGORIES.map((c) => (
              <button
                key={c}
                data-testid={`blog-cat-${c}`}
                onClick={() => setCat(c)}
                className={`rounded-full border px-4 py-2 text-sm font-semibold transition-colors ${
                  cat === c ? "border-aqua bg-aqua text-white" : "border-ink/15 text-ink/70 hover:border-aqua/50"
                }`}
              >
                {c}
              </button>
            ))}
          </div>

          <div className="grid gap-8 md:grid-cols-2 lg:grid-cols-3">
            {list.map((a, i) => (
              <Reveal key={a.slug} delay={i * 0.05}>
                <Link to={`/blog/${a.slug}`} data-testid={`blog-card-${a.slug}`} className="group block h-full rounded-3xl border border-ink/10 overflow-hidden hover:border-aqua/40 transition-colors">
                  <div className="overflow-hidden">
                    <img src={a.image} alt={a.title} className="h-52 w-full object-cover transition-transform duration-700 group-hover:scale-105" />
                  </div>
                  <div className="p-6">
                    <div className="flex items-center gap-3 text-xs">
                      <span className="rounded-full bg-aqua/10 px-3 py-1 font-bold text-aqua">{a.category}</span>
                      <span className="text-ink/40">{new Date(a.date).toLocaleDateString("fr-FR", { day: "numeric", month: "long", year: "numeric" })}</span>
                    </div>
                    <h2 className="mt-4 text-lg font-bold text-ink group-hover:text-aqua transition-colors leading-snug">{a.title}</h2>
                    <p className="mt-2 text-sm text-ink/60 leading-relaxed line-clamp-2">{a.excerpt}</p>
                    <span className="mt-4 inline-flex items-center gap-2 text-sm font-bold text-aqua">Lire l'article <ArrowRight size={16} /></span>
                  </div>
                </Link>
              </Reveal>
            ))}
          </div>
        </div>
      </section>

      <CTASection />
    </>
  );
}
